import Column from '@components/Column';
import styled from '@emotion/styled';

import ArrowUpIcon from './ArrowUpIcon';

interface Props {
    moveNext: () =>void;
    movePrev: () =>void;
}

function Remote({ movePrev, moveNext }:Props) {
    return (
        <Container spacing={8} >
            <ArrowUpIcon onClick={movePrev}/>
            <ArrowUpIcon onClick={moveNext}/>
        </Container>
    );
}

const Container = styled(Column)`
    background-color: var(--color-white);
    border-radius: 8px;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.14);
    padding: 4px;
    position: absolute;
    right: 28px;
    top: 28px;
    z-index: 2;

    svg:nth-last-of-type(1) {
        transform: rotate(180deg);
    }
`;

export default Remote;
